import { render, staticRenderFns } from "./ODpay_list.vue?vue&type=template&id=85c782cc&scoped=true"
import script from "./ODpay_list.vue?vue&type=script&lang=js"
export * from "./ODpay_list.vue?vue&type=script&lang=js"
import style0 from "./ODpay_list.vue?vue&type=style&index=0&id=85c782cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c782cc",
  null
  
)

export default component.exports